import { Panel } from "components/Panel/Panel";
import { Pick } from "model/Pickem/Pickem";
import { PointsPartition } from "model/PickemDetails/PointsPartition";
import { selectMatchRosterIds } from "selectors/Match";
import { RankemGrid } from "./Grid/RankemGrid";
import { useAppSelector } from "app/hooks";

interface Props {
  matchId: string;
  tournamentId: string;
  columns: PointsPartition[];
  picks: {
    [id: string]: Pick;
  };
  updatePick: (
    rosterId: string,
    groupRosterIds: string[],
    position: number | undefined
  ) => void;
  frozenRosters: { [id: string]: Pick } | undefined;
}

export const MatchRankemPicker = ({
  matchId,
  tournamentId,
  columns,
  picks,
  updatePick,
  frozenRosters,
}: Props) => {
  const rosterIds =
    useAppSelector((state) => selectMatchRosterIds(state, matchId)) ?? [];

  const frozenMatchRosters: { [id: string]: number } = {};
  if (!!frozenRosters) {
    Object.keys(frozenRosters).forEach((rosterId) => {
      if (rosterIds.includes(rosterId)) {
        const pick = frozenRosters[rosterId];
        if (typeof pick === "number") {
          frozenMatchRosters[rosterId] = pick;
        }
      }
    });
  }

  return (
    <Panel padding="padded">
      <RankemGrid
        columns={columns}
        gridRosterIds={rosterIds}
        tournamentId={tournamentId}
        picks={picks}
        updatePick={(rosterId, position) =>
          updatePick(rosterId, rosterIds, position)
        }
        frozenRosters={frozenMatchRosters}
      />
    </Panel>
  );
};
